/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurestatstitle2Inputs */

const he_extension_featurestatstitle2 = /** @type {(inputs: Extension_Featurestatstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סטטיסטיקות מתקדמות`)
};

const en_extension_featurestatstitle2 = /** @type {(inputs: Extension_Featurestatstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Statistics`)
};

/**
* | output |
* | --- |
* | "Advanced Statistics" |
*
* @param {Extension_Featurestatstitle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurestatstitle2 = /** @type {((inputs?: Extension_Featurestatstitle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurestatstitle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurestatstitle2(inputs)
	return en_extension_featurestatstitle2(inputs)
});
export { extension_featurestatstitle2 as "extension_featureStatsTitle" }